import React from 'react';

import { ErrorBoundaryState } from './interfaces';

class ErrorBoundary extends React.Component<unknown, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryState) {
    super(props);
    this.state = { error: undefined };
    this.reload = this.reload.bind(this);
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    console.log('ErrorBoundary.componentDidCatch()->', error, errorInfo);
  }

  reload = () => {
    this.setState({ error: undefined });
  };

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
